var cov_108sjousrt = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Input/Number.tsx",
      hash = "3786f757caa6aa4095daffe6b35df3220c2742d5",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Input/Number.tsx",
    statementMap: {
      "0": {
        start: {
          line: 10,
          column: 21
        },
        end: {
          line: 14,
          column: 1
        }
      },
      "1": {
        start: {
          line: 28,
          column: 4
        },
        end: {
          line: 28,
          column: 16
        }
      },
      "2": {
        start: {
          line: 30,
          column: 4
        },
        end: {
          line: 30,
          column: 48
        }
      },
      "3": {
        start: {
          line: 31,
          column: 4
        },
        end: {
          line: 31,
          column: 52
        }
      },
      "4": {
        start: {
          line: 32,
          column: 4
        },
        end: {
          line: 32,
          column: 64
        }
      },
      "5": {
        start: {
          line: 33,
          column: 4
        },
        end: {
          line: 33,
          column: 66
        }
      },
      "6": {
        start: {
          line: 34,
          column: 4
        },
        end: {
          line: 34,
          column: 54
        }
      },
      "7": {
        start: {
          line: 35,
          column: 4
        },
        end: {
          line: 35,
          column: 54
        }
      },
      "8": {
        start: {
          line: 36,
          column: 4
        },
        end: {
          line: 36,
          column: 50
        }
      },
      "9": {
        start: {
          line: 40,
          column: 4
        },
        end: {
          line: 40,
          column: 21
        }
      },
      "10": {
        start: {
          line: 41,
          column: 4
        },
        end: {
          line: 41,
          column: 64
        }
      },
      "11": {
        start: {
          line: 41,
          column: 30
        },
        end: {
          line: 41,
          column: 64
        }
      },
      "12": {
        start: {
          line: 49,
          column: 4
        },
        end: {
          line: 52,
          column: 5
        }
      },
      "13": {
        start: {
          line: 50,
          column: 6
        },
        end: {
          line: 50,
          column: 32
        }
      },
      "14": {
        start: {
          line: 51,
          column: 6
        },
        end: {
          line: 51,
          column: 12
        }
      },
      "15": {
        start: {
          line: 54,
          column: 4
        },
        end: {
          line: 59,
          column: 5
        }
      },
      "16": {
        start: {
          line: 55,
          column: 6
        },
        end: {
          line: 57,
          column: 7
        }
      },
      "17": {
        start: {
          line: 56,
          column: 8
        },
        end: {
          line: 56,
          column: 34
        }
      },
      "18": {
        start: {
          line: 58,
          column: 6
        },
        end: {
          line: 58,
          column: 12
        }
      },
      "19": {
        start: {
          line: 60,
          column: 94
        },
        end: {
          line: 60,
          column: 104
        }
      },
      "20": {
        start: {
          line: 62,
          column: 4
        },
        end: {
          line: 70,
          column: 5
        }
      },
      "21": {
        start: {
          line: 63,
          column: 6
        },
        end: {
          line: 63,
          column: 42
        }
      },
      "22": {
        start: {
          line: 64,
          column: 11
        },
        end: {
          line: 70,
          column: 5
        }
      },
      "23": {
        start: {
          line: 65,
          column: 6
        },
        end: {
          line: 65,
          column: 59
        }
      },
      "24": {
        start: {
          line: 67,
          column: 22
        },
        end: {
          line: 67,
          column: 37
        }
      },
      "25": {
        start: {
          line: 68,
          column: 18
        },
        end: {
          line: 68,
          column: 42
        }
      },
      "26": {
        start: {
          line: 69,
          column: 6
        },
        end: {
          line: 69,
          column: 87
        }
      },
      "27": {
        start: {
          line: 69,
          column: 20
        },
        end: {
          line: 69,
          column: 87
        }
      },
      "28": {
        start: {
          line: 72,
          column: 25
        },
        end: {
          line: 72,
          column: 35
        }
      },
      "29": {
        start: {
          line: 74,
          column: 4
        },
        end: {
          line: 74,
          column: 54
        }
      },
      "30": {
        start: {
          line: 74,
          column: 43
        },
        end: {
          line: 74,
          column: 54
        }
      },
      "31": {
        start: {
          line: 75,
          column: 4
        },
        end: {
          line: 75,
          column: 54
        }
      },
      "32": {
        start: {
          line: 75,
          column: 43
        },
        end: {
          line: 75,
          column: 54
        }
      },
      "33": {
        start: {
          line: 77,
          column: 4
        },
        end: {
          line: 79,
          column: 5
        }
      },
      "34": {
        start: {
          line: 78,
          column: 6
        },
        end: {
          line: 78,
          column: 32
        }
      },
      "35": {
        start: {
          line: 83,
          column: 4
        },
        end: {
          line: 83,
          column: 21
        }
      },
      "36": {
        start: {
          line: 84,
          column: 31
        },
        end: {
          line: 84,
          column: 57
        }
      },
      "37": {
        start: {
          line: 86,
          column: 4
        },
        end: {
          line: 88,
          column: 5
        }
      },
      "38": {
        start: {
          line: 87,
          column: 6
        },
        end: {
          line: 87,
          column: 18
        }
      },
      "39": {
        start: {
          line: 90,
          column: 4
        },
        end: {
          line: 90,
          column: 41
        }
      },
      "40": {
        start: {
          line: 90,
          column: 32
        },
        end: {
          line: 90,
          column: 41
        }
      },
      "41": {
        start: {
          line: 91,
          column: 4
        },
        end: {
          line: 95,
          column: 5
        }
      },
      "42": {
        start: {
          line: 92,
          column: 6
        },
        end: {
          line: 92,
          column: 46
        }
      },
      "43": {
        start: {
          line: 94,
          column: 6
        },
        end: {
          line: 94,
          column: 52
        }
      },
      "44": {
        start: {
          line: 96,
          column: 4
        },
        end: {
          line: 96,
          column: 24
        }
      },
      "45": {
        start: {
          line: 100,
          column: 4
        },
        end: {
          line: 100,
          column: 35
        }
      },
      "46": {
        start: {
          line: 100,
          column: 29
        },
        end: {
          line: 100,
          column: 35
        }
      },
      "47": {
        start: {
          line: 101,
          column: 14
        },
        end: {
          line: 101,
          column: 30
        }
      },
      "48": {
        start: {
          line: 102,
          column: 4
        },
        end: {
          line: 102,
          column: 28
        }
      },
      "49": {
        start: {
          line: 102,
          column: 19
        },
        end: {
          line: 102,
          column: 28
        }
      },
      "50": {
        start: {
          line: 103,
          column: 16
        },
        end: {
          line: 103,
          column: 60
        }
      },
      "51": {
        start: {
          line: 105,
          column: 4
        },
        end: {
          line: 105,
          column: 31
        }
      },
      "52": {
        start: {
          line: 105,
          column: 22
        },
        end: {
          line: 105,
          column: 31
        }
      },
      "53": {
        start: {
          line: 107,
          column: 38
        },
        end: {
          line: 107,
          column: 48
        }
      },
      "54": {
        start: {
          line: 109,
          column: 25
        },
        end: {
          line: 109,
          column: 40
        }
      },
      "55": {
        start: {
          line: 110,
          column: 4
        },
        end: {
          line: 112,
          column: 5
        }
      },
      "56": {
        start: {
          line: 111,
          column: 6
        },
        end: {
          line: 111,
          column: 12
        }
      },
      "57": {
        start: {
          line: 113,
          column: 4
        },
        end: {
          line: 115,
          column: 5
        }
      },
      "58": {
        start: {
          line: 114,
          column: 6
        },
        end: {
          line: 114,
          column: 12
        }
      },
      "59": {
        start: {
          line: 117,
          column: 4
        },
        end: {
          line: 119,
          column: 5
        }
      },
      "60": {
        start: {
          line: 118,
          column: 6
        },
        end: {
          line: 118,
          column: 12
        }
      },
      "61": {
        start: {
          line: 121,
          column: 4
        },
        end: {
          line: 121,
          column: 41
        }
      },
      "62": {
        start: {
          line: 125,
          column: 4
        },
        end: {
          line: 125,
          column: 26
        }
      },
      "63": {
        start: {
          line: 125,
          column: 20
        },
        end: {
          line: 125,
          column: 26
        }
      },
      "64": {
        start: {
          line: 126,
          column: 4
        },
        end: {
          line: 129,
          column: 10
        }
      },
      "65": {
        start: {
          line: 127,
          column: 6
        },
        end: {
          line: 127,
          column: 27
        }
      },
      "66": {
        start: {
          line: 128,
          column: 6
        },
        end: {
          line: 128,
          column: 25
        }
      },
      "67": {
        start: {
          line: 133,
          column: 41
        },
        end: {
          line: 133,
          column: 51
        }
      },
      "68": {
        start: {
          line: 134,
          column: 4
        },
        end: {
          line: 134,
          column: 20
        }
      },
      "69": {
        start: {
          line: 135,
          column: 4
        },
        end: {
          line: 135,
          column: 52
        }
      },
      "70": {
        start: {
          line: 135,
          column: 46
        },
        end: {
          line: 135,
          column: 52
        }
      },
      "71": {
        start: {
          line: 136,
          column: 4
        },
        end: {
          line: 136,
          column: 22
        }
      },
      "72": {
        start: {
          line: 137,
          column: 16
        },
        end: {
          line: 137,
          column: 47
        }
      },
      "73": {
        start: {
          line: 138,
          column: 4
        },
        end: {
          line: 138,
          column: 25
        }
      },
      "74": {
        start: {
          line: 139,
          column: 4
        },
        end: {
          line: 139,
          column: 64
        }
      },
      "75": {
        start: {
          line: 139,
          column: 30
        },
        end: {
          line: 139,
          column: 64
        }
      },
      "76": {
        start: {
          line: 140,
          column: 4
        },
        end: {
          line: 142,
          column: 11
        }
      },
      "77": {
        start: {
          line: 141,
          column: 6
        },
        end: {
          line: 141,
          column: 25
        }
      },
      "78": {
        start: {
          line: 146,
          column: 28
        },
        end: {
          line: 146,
          column: 38
        }
      },
      "79": {
        start: {
          line: 147,
          column: 4
        },
        end: {
          line: 147,
          column: 35
        }
      },
      "80": {
        start: {
          line: 147,
          column: 21
        },
        end: {
          line: 147,
          column: 35
        }
      },
      "81": {
        start: {
          line: 148,
          column: 4
        },
        end: {
          line: 148,
          column: 20
        }
      },
      "82": {
        start: {
          line: 149,
          column: 4
        },
        end: {
          line: 149,
          column: 25
        }
      },
      "83": {
        start: {
          line: 150,
          column: 4
        },
        end: {
          line: 152,
          column: 12
        }
      },
      "84": {
        start: {
          line: 151,
          column: 6
        },
        end: {
          line: 151,
          column: 25
        }
      },
      "85": {
        start: {
          line: 156,
          column: 4
        },
        end: {
          line: 156,
          column: 21
        }
      },
      "86": {
        start: {
          line: 157,
          column: 4
        },
        end: {
          line: 157,
          column: 64
        }
      },
      "87": {
        start: {
          line: 157,
          column: 30
        },
        end: {
          line: 157,
          column: 64
        }
      },
      "88": {
        start: {
          line: 161,
          column: 26
        },
        end: {
          line: 161,
          column: 36
        }
      },
      "89": {
        start: {
          line: 162,
          column: 4
        },
        end: {
          line: 162,
          column: 31
        }
      },
      "90": {
        start: {
          line: 162,
          column: 19
        },
        end: {
          line: 162,
          column: 31
        }
      },
      "91": {
        start: {
          line: 163,
          column: 4
        },
        end: {
          line: 163,
          column: 21
        }
      },
      "92": {
        start: {
          line: 164,
          column: 4
        },
        end: {
          line: 164,
          column: 64
        }
      },
      "93": {
        start: {
          line: 164,
          column: 30
        },
        end: {
          line: 164,
          column: 64
        }
      },
      "94": {
        start: {
          line: 168,
          column: 26
        },
        end: {
          line: 168,
          column: 36
        }
      },
      "95": {
        start: {
          line: 169,
          column: 4
        },
        end: {
          line: 169,
          column: 28
        }
      },
      "96": {
        start: {
          line: 169,
          column: 19
        },
        end: {
          line: 169,
          column: 28
        }
      },
      "97": {
        start: {
          line: 170,
          column: 4
        },
        end: {
          line: 194,
          column: 5
        }
      },
      "98": {
        start: {
          line: 198,
          column: 78
        },
        end: {
          line: 198,
          column: 88
        }
      },
      "99": {
        start: {
          line: 199,
          column: 4
        },
        end: {
          line: 213,
          column: 5
        }
      },
      "100": {
        start: {
          line: 217,
          column: 78
        },
        end: {
          line: 217,
          column: 88
        }
      },
      "101": {
        start: {
          line: 218,
          column: 16
        },
        end: {
          line: 218,
          column: 23
        }
      },
      "102": {
        start: {
          line: 219,
          column: 4
        },
        end: {
          line: 221,
          column: 5
        }
      },
      "103": {
        start: {
          line: 220,
          column: 6
        },
        end: {
          line: 220,
          column: 29
        }
      },
      "104": {
        start: {
          line: 222,
          column: 4
        },
        end: {
          line: 236,
          column: 5
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 27,
            column: 2
          },
          end: {
            line: 27,
            column: 3
          }
        },
        loc: {
          start: {
            line: 27,
            column: 34
          },
          end: {
            line: 37,
            column: 3
          }
        },
        line: 27
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 39,
            column: 2
          },
          end: {
            line: 39,
            column: 3
          }
        },
        loc: {
          start: {
            line: 39,
            column: 25
          },
          end: {
            line: 42,
            column: 3
          }
        },
        line: 39
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 48,
            column: 2
          },
          end: {
            line: 48,
            column: 3
          }
        },
        loc: {
          start: {
            line: 48,
            column: 76
          },
          end: {
            line: 80,
            column: 3
          }
        },
        line: 48
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 82,
            column: 2
          },
          end: {
            line: 82,
            column: 3
          }
        },
        loc: {
          start: {
            line: 82,
            column: 52
          },
          end: {
            line: 97,
            column: 3
          }
        },
        line: 82
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 99,
            column: 2
          },
          end: {
            line: 99,
            column: 3
          }
        },
        loc: {
          start: {
            line: 99,
            column: 27
          },
          end: {
            line: 122,
            column: 3
          }
        },
        line: 99
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 124,
            column: 2
          },
          end: {
            line: 124,
            column: 3
          }
        },
        loc: {
          start: {
            line: 124,
            column: 25
          },
          end: {
            line: 130,
            column: 3
          }
        },
        line: 124
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 126,
            column: 15
          },
          end: {
            line: 126,
            column: 16
          }
        },
        loc: {
          start: {
            line: 126,
            column: 21
          },
          end: {
            line: 129,
            column: 5
          }
        },
        line: 126
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 132,
            column: 2
          },
          end: {
            line: 132,
            column: 3
          }
        },
        loc: {
          start: {
            line: 132,
            column: 40
          },
          end: {
            line: 143,
            column: 3
          }
        },
        line: 132
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 140,
            column: 38
          },
          end: {
            line: 140,
            column: 39
          }
        },
        loc: {
          start: {
            line: 140,
            column: 44
          },
          end: {
            line: 142,
            column: 5
          }
        },
        line: 140
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 145,
            column: 2
          },
          end: {
            line: 145,
            column: 3
          }
        },
        loc: {
          start: {
            line: 145,
            column: 47
          },
          end: {
            line: 153,
            column: 3
          }
        },
        line: 145
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 150,
            column: 38
          },
          end: {
            line: 150,
            column: 39
          }
        },
        loc: {
          start: {
            line: 150,
            column: 44
          },
          end: {
            line: 152,
            column: 5
          }
        },
        line: 150
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 155,
            column: 2
          },
          end: {
            line: 155,
            column: 3
          }
        },
        loc: {
          start: {
            line: 155,
            column: 16
          },
          end: {
            line: 158,
            column: 3
          }
        },
        line: 155
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 160,
            column: 2
          },
          end: {
            line: 160,
            column: 3
          }
        },
        loc: {
          start: {
            line: 160,
            column: 37
          },
          end: {
            line: 165,
            column: 3
          }
        },
        line: 160
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 167,
            column: 2
          },
          end: {
            line: 167,
            column: 3
          }
        },
        loc: {
          start: {
            line: 167,
            column: 21
          },
          end: {
            line: 195,
            column: 3
          }
        },
        line: 167
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 197,
            column: 2
          },
          end: {
            line: 197,
            column: 3
          }
        },
        loc: {
          start: {
            line: 197,
            column: 14
          },
          end: {
            line: 214,
            column: 3
          }
        },
        line: 197
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 216,
            column: 2
          },
          end: {
            line: 216,
            column: 3
          }
        },
        loc: {
          start: {
            line: 216,
            column: 11
          },
          end: {
            line: 237,
            column: 3
          }
        },
        line: 216
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 41,
            column: 4
          },
          end: {
            line: 41,
            column: 64
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 41,
            column: 4
          },
          end: {
            line: 41,
            column: 64
          }
        }, {
          start: {
            line: 41,
            column: 4
          },
          end: {
            line: 41,
            column: 64
          }
        }],
        line: 41
      },
      "1": {
        loc: {
          start: {
            line: 49,
            column: 4
          },
          end: {
            line: 52,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 49,
            column: 4
          },
          end: {
            line: 52,
            column: 5
          }
        }, {
          start: {
            line: 49,
            column: 4
          },
          end: {
            line: 52,
            column: 5
          }
        }],
        line: 49
      },
      "2": {
        loc: {
          start: {
            line: 49,
            column: 8
          },
          end: {
            line: 49,
            column: 38
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 49,
            column: 8
          },
          end: {
            line: 49,
            column: 15
          }
        }, {
          start: {
            line: 49,
            column: 19
          },
          end: {
            line: 49,
            column: 38
          }
        }],
        line: 49
      },
      "3": {
        loc: {
          start: {
            line: 54,
            column: 4
          },
          end: {
            line: 59,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 54,
            column: 4
          },
          end: {
            line: 59,
            column: 5
          }
        }, {
          start: {
            line: 54,
            column: 4
          },
          end: {
            line: 59,
            column: 5
          }
        }],
        line: 54
      },
      "4": {
        loc: {
          start: {
            line: 55,
            column: 6
          },
          end: {
            line: 57,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 55,
            column: 6
          },
          end: {
            line: 57,
            column: 7
          }
        }, {
          start: {
            line: 55,
            column: 6
          },
          end: {
            line: 57,
            column: 7
          }
        }],
        line: 55
      },
      "5": {
        loc: {
          start: {
            line: 60,
            column: 20
          },
          end: {
            line: 60,
            column: 44
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 60,
            column: 27
          },
          end: {
            line: 60,
            column: 44
          }
        }],
        line: 60
      },
      "6": {
        loc: {
          start: {
            line: 60,
            column: 55
          },
          end: {
            line: 60,
            column: 89
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 60,
            column: 67
          },
          end: {
            line: 60,
            column: 89
          }
        }],
        line: 60
      },
      "7": {
        loc: {
          start: {
            line: 62,
            column: 4
          },
          end: {
            line: 70,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 62,
            column: 4
          },
          end: {
            line: 70,
            column: 5
          }
        }, {
          start: {
            line: 62,
            column: 4
          },
          end: {
            line: 70,
            column: 5
          }
        }],
        line: 62
      },
      "8": {
        loc: {
          start: {
            line: 62,
            column: 8
          },
          end: {
            line: 62,
            column: 45
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 62,
            column: 8
          },
          end: {
            line: 62,
            column: 30
          }
        }, {
          start: {
            line: 62,
            column: 34
          },
          end: {
            line: 62,
            column: 45
          }
        }],
        line: 62
      },
      "9": {
        loc: {
          start: {
            line: 63,
            column: 14
          },
          end: {
            line: 63,
            column: 42
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 63,
            column: 26
          },
          end: {
            line: 63,
            column: 30
          }
        }, {
          start: {
            line: 63,
            column: 33
          },
          end: {
            line: 63,
            column: 42
          }
        }],
        line: 63
      },
      "10": {
        loc: {
          start: {
            line: 64,
            column: 11
          },
          end: {
            line: 70,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 64,
            column: 11
          },
          end: {
            line: 70,
            column: 5
          }
        }, {
          start: {
            line: 64,
            column: 11
          },
          end: {
            line: 70,
            column: 5
          }
        }],
        line: 64
      },
      "11": {
        loc: {
          start: {
            line: 69,
            column: 6
          },
          end: {
            line: 69,
            column: 87
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 69,
            column: 6
          },
          end: {
            line: 69,
            column: 87
          }
        }, {
          start: {
            line: 69,
            column: 6
          },
          end: {
            line: 69,
            column: 87
          }
        }],
        line: 69
      },
      "12": {
        loc: {
          start: {
            line: 74,
            column: 4
          },
          end: {
            line: 74,
            column: 54
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 74,
            column: 4
          },
          end: {
            line: 74,
            column: 54
          }
        }, {
          start: {
            line: 74,
            column: 4
          },
          end: {
            line: 74,
            column: 54
          }
        }],
        line: 74
      },
      "13": {
        loc: {
          start: {
            line: 74,
            column: 8
          },
          end: {
            line: 74,
            column: 41
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 74,
            column: 8
          },
          end: {
            line: 74,
            column: 25
          }
        }, {
          start: {
            line: 74,
            column: 29
          },
          end: {
            line: 74,
            column: 41
          }
        }],
        line: 74
      },
      "14": {
        loc: {
          start: {
            line: 75,
            column: 4
          },
          end: {
            line: 75,
            column: 54
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 75,
            column: 4
          },
          end: {
            line: 75,
            column: 54
          }
        }, {
          start: {
            line: 75,
            column: 4
          },
          end: {
            line: 75,
            column: 54
          }
        }],
        line: 75
      },
      "15": {
        loc: {
          start: {
            line: 75,
            column: 8
          },
          end: {
            line: 75,
            column: 41
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 75,
            column: 8
          },
          end: {
            line: 75,
            column: 25
          }
        }, {
          start: {
            line: 75,
            column: 29
          },
          end: {
            line: 75,
            column: 41
          }
        }],
        line: 75
      },
      "16": {
        loc: {
          start: {
            line: 77,
            column: 4
          },
          end: {
            line: 79,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 77,
            column: 4
          },
          end: {
            line: 79,
            column: 5
          }
        }, {
          start: {
            line: 77,
            column: 4
          },
          end: {
            line: 79,
            column: 5
          }
        }],
        line: 77
      },
      "17": {
        loc: {
          start: {
            line: 86,
            column: 4
          },
          end: {
            line: 88,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 86,
            column: 4
          },
          end: {
            line: 88,
            column: 5
          }
        }, {
          start: {
            line: 86,
            column: 4
          },
          end: {
            line: 88,
            column: 5
          }
        }],
        line: 86
      },
      "18": {
        loc: {
          start: {
            line: 86,
            column: 8
          },
          end: {
            line: 86,
            column: 53
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 86,
            column: 8
          },
          end: {
            line: 86,
            column: 29
          }
        }, {
          start: {
            line: 86,
            column: 33
          },
          end: {
            line: 86,
            column: 53
          }
        }],
        line: 86
      },
      "19": {
        loc: {
          start: {
            line: 90,
            column: 4
          },
          end: {
            line: 90,
            column: 41
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 90,
            column: 4
          },
          end: {
            line: 90,
            column: 41
          }
        }, {
          start: {
            line: 90,
            column: 4
          },
          end: {
            line: 90,
            column: 41
          }
        }],
        line: 90
      },
      "20": {
        loc: {
          start: {
            line: 91,
            column: 4
          },
          end: {
            line: 95,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 91,
            column: 4
          },
          end: {
            line: 95,
            column: 5
          }
        }, {
          start: {
            line: 91,
            column: 4
          },
          end: {
            line: 95,
            column: 5
          }
        }],
        line: 91
      },
      "21": {
        loc: {
          start: {
            line: 91,
            column: 8
          },
          end: {
            line: 91,
            column: 94
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 91,
            column: 8
          },
          end: {
            line: 91,
            column: 35
          }
        }, {
          start: {
            line: 91,
            column: 39
          },
          end: {
            line: 91,
            column: 60
          }
        }, {
          start: {
            line: 91,
            column: 64
          },
          end: {
            line: 91,
            column: 94
          }
        }],
        line: 91
      },
      "22": {
        loc: {
          start: {
            line: 100,
            column: 4
          },
          end: {
            line: 100,
            column: 35
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 100,
            column: 4
          },
          end: {
            line: 100,
            column: 35
          }
        }, {
          start: {
            line: 100,
            column: 4
          },
          end: {
            line: 100,
            column: 35
          }
        }],
        line: 100
      },
      "23": {
        loc: {
          start: {
            line: 102,
            column: 4
          },
          end: {
            line: 102,
            column: 28
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 102,
            column: 4
          },
          end: {
            line: 102,
            column: 28
          }
        }, {
          start: {
            line: 102,
            column: 4
          },
          end: {
            line: 102,
            column: 28
          }
        }],
        line: 102
      },
      "24": {
        loc: {
          start: {
            line: 103,
            column: 30
          },
          end: {
            line: 103,
            column: 39
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 103,
            column: 30
          },
          end: {
            line: 103,
            column: 33
          }
        }, {
          start: {
            line: 103,
            column: 37
          },
          end: {
            line: 103,
            column: 39
          }
        }],
        line: 103
      },
      "25": {
        loc: {
          start: {
            line: 105,
            column: 4
          },
          end: {
            line: 105,
            column: 31
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 105,
            column: 4
          },
          end: {
            line: 105,
            column: 31
          }
        }, {
          start: {
            line: 105,
            column: 4
          },
          end: {
            line: 105,
            column: 31
          }
        }],
        line: 105
      },
      "26": {
        loc: {
          start: {
            line: 110,
            column: 4
          },
          end: {
            line: 112,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 110,
            column: 4
          },
          end: {
            line: 112,
            column: 5
          }
        }, {
          start: {
            line: 110,
            column: 4
          },
          end: {
            line: 112,
            column: 5
          }
        }],
        line: 110
      },
      "27": {
        loc: {
          start: {
            line: 110,
            column: 8
          },
          end: {
            line: 110,
            column: 51
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 110,
            column: 8
          },
          end: {
            line: 110,
            column: 30
          }
        }, {
          start: {
            line: 110,
            column: 34
          },
          end: {
            line: 110,
            column: 51
          }
        }],
        line: 110
      },
      "28": {
        loc: {
          start: {
            line: 113,
            column: 4
          },
          end: {
            line: 115,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 113,
            column: 4
          },
          end: {
            line: 115,
            column: 5
          }
        }, {
          start: {
            line: 113,
            column: 4
          },
          end: {
            line: 115,
            column: 5
          }
        }],
        line: 113
      },
      "29": {
        loc: {
          start: {
            line: 113,
            column: 8
          },
          end: {
            line: 113,
            column: 54
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 113,
            column: 8
          },
          end: {
            line: 113,
            column: 34
          }
        }, {
          start: {
            line: 113,
            column: 38
          },
          end: {
            line: 113,
            column: 54
          }
        }],
        line: 113
      },
      "30": {
        loc: {
          start: {
            line: 117,
            column: 4
          },
          end: {
            line: 119,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 117,
            column: 4
          },
          end: {
            line: 119,
            column: 5
          }
        }, {
          start: {
            line: 117,
            column: 4
          },
          end: {
            line: 119,
            column: 5
          }
        }],
        line: 117
      },
      "31": {
        loc: {
          start: {
            line: 117,
            column: 8
          },
          end: {
            line: 117,
            column: 103
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 117,
            column: 8
          },
          end: {
            line: 117,
            column: 20
          }
        }, {
          start: {
            line: 117,
            column: 24
          },
          end: {
            line: 117,
            column: 103
          }
        }],
        line: 117
      },
      "32": {
        loc: {
          start: {
            line: 125,
            column: 4
          },
          end: {
            line: 125,
            column: 26
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 125,
            column: 4
          },
          end: {
            line: 125,
            column: 26
          }
        }, {
          start: {
            line: 125,
            column: 4
          },
          end: {
            line: 125,
            column: 26
          }
        }],
        line: 125
      },
      "33": {
        loc: {
          start: {
            line: 133,
            column: 12
          },
          end: {
            line: 133,
            column: 36
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 133,
            column: 19
          },
          end: {
            line: 133,
            column: 36
          }
        }],
        line: 133
      },
      "34": {
        loc: {
          start: {
            line: 135,
            column: 4
          },
          end: {
            line: 135,
            column: 52
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 135,
            column: 4
          },
          end: {
            line: 135,
            column: 52
          }
        }, {
          start: {
            line: 135,
            column: 4
          },
          end: {
            line: 135,
            column: 52
          }
        }],
        line: 135
      },
      "35": {
        loc: {
          start: {
            line: 135,
            column: 8
          },
          end: {
            line: 135,
            column: 44
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 135,
            column: 8
          },
          end: {
            line: 135,
            column: 24
          }
        }, {
          start: {
            line: 135,
            column: 28
          },
          end: {
            line: 135,
            column: 44
          }
        }],
        line: 135
      },
      "36": {
        loc: {
          start: {
            line: 137,
            column: 16
          },
          end: {
            line: 137,
            column: 47
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 137,
            column: 35
          },
          end: {
            line: 137,
            column: 39
          }
        }, {
          start: {
            line: 137,
            column: 42
          },
          end: {
            line: 137,
            column: 47
          }
        }],
        line: 137
      },
      "37": {
        loc: {
          start: {
            line: 139,
            column: 4
          },
          end: {
            line: 139,
            column: 64
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 139,
            column: 4
          },
          end: {
            line: 139,
            column: 64
          }
        }, {
          start: {
            line: 139,
            column: 4
          },
          end: {
            line: 139,
            column: 64
          }
        }],
        line: 139
      },
      "38": {
        loc: {
          start: {
            line: 147,
            column: 4
          },
          end: {
            line: 147,
            column: 35
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 147,
            column: 4
          },
          end: {
            line: 147,
            column: 35
          }
        }, {
          start: {
            line: 147,
            column: 4
          },
          end: {
            line: 147,
            column: 35
          }
        }],
        line: 147
      },
      "39": {
        loc: {
          start: {
            line: 157,
            column: 4
          },
          end: {
            line: 157,
            column: 64
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 157,
            column: 4
          },
          end: {
            line: 157,
            column: 64
          }
        }, {
          start: {
            line: 157,
            column: 4
          },
          end: {
            line: 157,
            column: 64
          }
        }],
        line: 157
      },
      "40": {
        loc: {
          start: {
            line: 162,
            column: 4
          },
          end: {
            line: 162,
            column: 31
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 162,
            column: 4
          },
          end: {
            line: 162,
            column: 31
          }
        }, {
          start: {
            line: 162,
            column: 4
          },
          end: {
            line: 162,
            column: 31
          }
        }],
        line: 162
      },
      "41": {
        loc: {
          start: {
            line: 164,
            column: 4
          },
          end: {
            line: 164,
            column: 64
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 164,
            column: 4
          },
          end: {
            line: 164,
            column: 64
          }
        }, {
          start: {
            line: 164,
            column: 4
          },
          end: {
            line: 164,
            column: 64
          }
        }],
        line: 164
      },
      "42": {
        loc: {
          start: {
            line: 169,
            column: 4
          },
          end: {
            line: 169,
            column: 28
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 169,
            column: 4
          },
          end: {
            line: 169,
            column: 28
          }
        }, {
          start: {
            line: 169,
            column: 4
          },
          end: {
            line: 169,
            column: 28
          }
        }],
        line: 169
      },
      "43": {
        loc: {
          start: {
            line: 205,
            column: 30
          },
          end: {
            line: 205,
            column: 71
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 205,
            column: 30
          },
          end: {
            line: 205,
            column: 40
          }
        }, {
          start: {
            line: 205,
            column: 44
          },
          end: {
            line: 205,
            column: 71
          }
        }],
        line: 205
      },
      "44": {
        loc: {
          start: {
            line: 219,
            column: 4
          },
          end: {
            line: 221,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 219,
            column: 4
          },
          end: {
            line: 221,
            column: 5
          }
        }, {
          start: {
            line: 219,
            column: 4
          },
          end: {
            line: 221,
            column: 5
          }
        }],
        line: 219
      },
      "45": {
        loc: {
          start: {
            line: 227,
            column: 30
          },
          end: {
            line: 227,
            column: 71
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 227,
            column: 30
          },
          end: {
            line: 227,
            column: 40
          }
        }, {
          start: {
            line: 227,
            column: 44
          },
          end: {
            line: 227,
            column: 71
          }
        }],
        line: 227
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0,
      "82": 0,
      "83": 0,
      "84": 0,
      "85": 0,
      "86": 0,
      "87": 0,
      "88": 0,
      "89": 0,
      "90": 0,
      "91": 0,
      "92": 0,
      "93": 0,
      "94": 0,
      "95": 0,
      "96": 0,
      "97": 0,
      "98": 0,
      "99": 0,
      "100": 0,
      "101": 0,
      "102": 0,
      "103": 0,
      "104": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0],
      "6": [0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0, 0],
      "26": [0, 0],
      "27": [0, 0],
      "28": [0, 0],
      "29": [0, 0],
      "30": [0, 0],
      "31": [0, 0],
      "32": [0, 0],
      "33": [0],
      "34": [0, 0],
      "35": [0, 0],
      "36": [0, 0],
      "37": [0, 0],
      "38": [0, 0],
      "39": [0, 0],
      "40": [0, 0],
      "41": [0, 0],
      "42": [0, 0],
      "43": [0, 0],
      "44": [0, 0],
      "45": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _toConsumableArray from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _objectWithoutProperties from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/spana/SHEIN/shineout/src/Input/Number.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import icons from '../icons';
import Input from './Input';
import { inputClass } from './styles';
import { isRTL } from '../config';
import { sub } from '../utils/numbers';
import { getDirectionClass } from '../utils/classname';
var DefaultValue = (cov_108sjousrt.s[0]++, {
  step: 1,
  allowNull: false,
  hideArrow: false
});

var Number =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Number, _PureComponent);

  var _super = _createSuper2(Number);

  function Number(props) {
    var _this;

    _classCallCheck(this, Number);

    cov_108sjousrt.f[0]++;
    cov_108sjousrt.s[1]++;
    _this = _super.call(this, props);
    _this.hold = void 0;
    _this.handleAddClick = void 0;
    _this.handleSubClick = void 0;
    _this.keyPressTimeOut = void 0;
    cov_108sjousrt.s[2]++;
    _this.handleBlur = _this.handleBlur.bind(_assertThisInitialized(_this));
    cov_108sjousrt.s[3]++;
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    cov_108sjousrt.s[4]++;
    _this.handleAddClick = _this.handleCalc.bind(_assertThisInitialized(_this), props.step);
    cov_108sjousrt.s[5]++;
    _this.handleSubClick = _this.handleCalc.bind(_assertThisInitialized(_this), -props.step);
    cov_108sjousrt.s[6]++;
    _this.handleMouseUp = _this.handleMouseUp.bind(_assertThisInitialized(_this));
    cov_108sjousrt.s[7]++;
    _this.handleKeyDown = _this.handleKeyDown.bind(_assertThisInitialized(_this));
    cov_108sjousrt.s[8]++;
    _this.handleKeyUp = _this.handleKeyUp.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Number, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      cov_108sjousrt.f[1]++;
      cov_108sjousrt.s[9]++;
      this.hold = false;
      cov_108sjousrt.s[10]++;

      if (this.keyPressTimeOut) {
        cov_108sjousrt.b[0][0]++;
        cov_108sjousrt.s[11]++;
        clearTimeout(this.keyPressTimeOut);
      } else {
        cov_108sjousrt.b[0][1]++;
      }
    } // handleChange(value: NumberValue) {
    //   this.handleChange(NumberValue)
    // }

  }, {
    key: "handleChange",
    value: function handleChange(value, check, isEmpty) {
      cov_108sjousrt.f[2]++;
      cov_108sjousrt.s[12]++;

      if ((cov_108sjousrt.b[2][0]++, isEmpty) || (cov_108sjousrt.b[2][1]++, value === undefined)) {
        cov_108sjousrt.b[1][0]++;
        cov_108sjousrt.s[13]++;
        this.props.onChange(value);
        cov_108sjousrt.s[14]++;
        return;
      } else {
        cov_108sjousrt.b[1][1]++;
      }

      cov_108sjousrt.s[15]++;

      if (!check) {
        cov_108sjousrt.b[3][0]++;
        cov_108sjousrt.s[16]++;

        if (new RegExp('^-?\\d*\\.?\\d*$').test(value)) {
          cov_108sjousrt.b[4][0]++;
          cov_108sjousrt.s[17]++;
          this.props.onChange(value);
        } else {
          cov_108sjousrt.b[4][1]++;
        }

        cov_108sjousrt.s[18]++;
        return;
      } else {
        cov_108sjousrt.b[3][1]++;
      }

      var _ref = (cov_108sjousrt.s[19]++, this.props),
          digits = _ref.digits,
          _ref$step = _ref.step,
          step = _ref$step === void 0 ? (cov_108sjousrt.b[5][0]++, DefaultValue.step) : _ref$step,
          numType = _ref.numType,
          _ref$allowNull = _ref.allowNull,
          allowNull = _ref$allowNull === void 0 ? (cov_108sjousrt.b[6][0]++, DefaultValue.allowNull) : _ref$allowNull;

      cov_108sjousrt.s[20]++;

      if ((cov_108sjousrt.b[8][0]++, numType === 'positive') && (cov_108sjousrt.b[8][1]++, value <= 0)) {
        cov_108sjousrt.b[7][0]++;
        cov_108sjousrt.s[21]++;
        value = allowNull ? (cov_108sjousrt.b[9][0]++, null) : (cov_108sjousrt.b[9][1]++, undefined);
      } else {
        cov_108sjousrt.b[7][1]++;
        cov_108sjousrt.s[22]++;

        if (typeof digits === 'number') {
          cov_108sjousrt.b[10][0]++;
          cov_108sjousrt.s[23]++;
          value = parseFloat(value.toFixed(digits));
        } else {
          cov_108sjousrt.b[10][1]++;
          var stepStr = (cov_108sjousrt.s[24]++, step.toString());
          var dot = (cov_108sjousrt.s[25]++, stepStr.lastIndexOf('.'));
          cov_108sjousrt.s[26]++;

          if (dot >= 0) {
            cov_108sjousrt.b[11][0]++;
            cov_108sjousrt.s[27]++;
            value = parseFloat(value.toFixed(stepStr.length - dot));
          } else {
            cov_108sjousrt.b[11][1]++;
          }
        }
      }

      var _ref2 = (cov_108sjousrt.s[28]++, this.props),
          min = _ref2.min,
          max = _ref2.max;

      cov_108sjousrt.s[29]++;

      if ((cov_108sjousrt.b[13][0]++, max !== undefined) && (cov_108sjousrt.b[13][1]++, value > max)) {
        cov_108sjousrt.b[12][0]++;
        cov_108sjousrt.s[30]++;
        value = max;
      } else {
        cov_108sjousrt.b[12][1]++;
      }

      cov_108sjousrt.s[31]++;

      if ((cov_108sjousrt.b[15][0]++, min !== undefined) && (cov_108sjousrt.b[15][1]++, value < min)) {
        cov_108sjousrt.b[14][0]++;
        cov_108sjousrt.s[32]++;
        value = min;
      } else {
        cov_108sjousrt.b[14][1]++;
      }

      cov_108sjousrt.s[33]++;

      if (value !== this.props.value) {
        cov_108sjousrt.b[16][0]++;
        cov_108sjousrt.s[34]++;
        this.props.onChange(value);
      } else {
        cov_108sjousrt.b[16][1]++;
      }
    }
  }, {
    key: "handleBlur",
    value: function handleBlur(e) {
      cov_108sjousrt.f[3]++;
      cov_108sjousrt.s[35]++;
      this.hold = false;
      var value = (cov_108sjousrt.s[36]++, parseFloat(e.target.value)); // for the empty

      cov_108sjousrt.s[37]++;

      if ((cov_108sjousrt.b[18][0]++, e.target.value === '') && (cov_108sjousrt.b[18][1]++, this.props.allowNull)) {
        cov_108sjousrt.b[17][0]++;
        cov_108sjousrt.s[38]++;
        value = null;
      } else {
        cov_108sjousrt.b[17][1]++;
      } // eslint-disable-next-line no-restricted-globals


      cov_108sjousrt.s[39]++;

      if (isNaN(value)) {
        cov_108sjousrt.b[19][0]++;
        cov_108sjousrt.s[40]++;
        value = 0;
      } else {
        cov_108sjousrt.b[19][1]++;
      }

      cov_108sjousrt.s[41]++;

      if ((cov_108sjousrt.b[21][0]++, this.props.clearToUndefined) && (cov_108sjousrt.b[21][1]++, e.target.value === '') && (cov_108sjousrt.b[21][2]++, this.props.value === undefined)) {
        cov_108sjousrt.b[20][0]++;
        cov_108sjousrt.s[42]++;
        this.handleChange(undefined, true, true);
      } else {
        cov_108sjousrt.b[20][1]++;
        cov_108sjousrt.s[43]++;
        this.handleChange(value, true, value === null);
      }

      cov_108sjousrt.s[44]++;
      this.props.onBlur(e);
    }
  }, {
    key: "changeValue",
    value: function changeValue(mod) {
      cov_108sjousrt.f[4]++;
      cov_108sjousrt.s[45]++;

      if (this.props.disabled) {
        cov_108sjousrt.b[22][0]++;
        cov_108sjousrt.s[46]++;
        return;
      } else {
        cov_108sjousrt.b[22][1]++;
      }

      var val = (cov_108sjousrt.s[47]++, this.props.value);
      cov_108sjousrt.s[48]++;

      if (val === 0) {
        cov_108sjousrt.b[23][0]++;
        cov_108sjousrt.s[49]++;
        val = '0';
      } else {
        cov_108sjousrt.b[23][1]++;
      }

      var value = (cov_108sjousrt.s[50]++, parseFloat("".concat((cov_108sjousrt.b[24][0]++, val) || (cov_108sjousrt.b[24][1]++, '')).replace(/,/g, ''))); // eslint-disable-next-line

      cov_108sjousrt.s[51]++;

      if (isNaN(value)) {
        cov_108sjousrt.b[25][0]++;
        cov_108sjousrt.s[52]++;
        value = 0;
      } else {
        cov_108sjousrt.b[25][1]++;
      }

      var _ref3 = (cov_108sjousrt.s[53]++, this.props),
          numType = _ref3.numType,
          integerLimit = _ref3.integerLimit;

      var calculateVal = (cov_108sjousrt.s[54]++, sub(value, mod));
      cov_108sjousrt.s[55]++;

      if ((cov_108sjousrt.b[27][0]++, numType === 'positive') && (cov_108sjousrt.b[27][1]++, calculateVal <= 0)) {
        cov_108sjousrt.b[26][0]++;
        cov_108sjousrt.s[56]++;
        return;
      } else {
        cov_108sjousrt.b[26][1]++;
      }

      cov_108sjousrt.s[57]++;

      if ((cov_108sjousrt.b[29][0]++, numType === 'non-negative') && (cov_108sjousrt.b[29][1]++, calculateVal < 0)) {
        cov_108sjousrt.b[28][0]++;
        cov_108sjousrt.s[58]++;
        return;
      } else {
        cov_108sjousrt.b[28][1]++;
      }

      cov_108sjousrt.s[59]++;

      if ((cov_108sjousrt.b[31][0]++, integerLimit) && (cov_108sjousrt.b[31][1]++, String(parseInt(calculateVal, 10)).length > integerLimit)) {
        cov_108sjousrt.b[30][0]++;
        cov_108sjousrt.s[60]++;
        return;
      } else {
        cov_108sjousrt.b[30][1]++;
      }

      cov_108sjousrt.s[61]++;
      this.handleChange(calculateVal, true);
    }
  }, {
    key: "longPress",
    value: function longPress(mod) {
      var _this2 = this;

      cov_108sjousrt.f[5]++;
      cov_108sjousrt.s[62]++;

      if (!this.hold) {
        cov_108sjousrt.b[32][0]++;
        cov_108sjousrt.s[63]++;
        return;
      } else {
        cov_108sjousrt.b[32][1]++;
      }

      cov_108sjousrt.s[64]++;
      setTimeout(function () {
        cov_108sjousrt.f[6]++;
        cov_108sjousrt.s[65]++;

        _this2.changeValue(mod);

        cov_108sjousrt.s[66]++;

        _this2.longPress(mod);
      }, 50);
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(e) {
      var _this3 = this;

      cov_108sjousrt.f[7]++;

      var _ref4 = (cov_108sjousrt.s[67]++, this.props),
          _ref4$step = _ref4.step,
          step = _ref4$step === void 0 ? (cov_108sjousrt.b[33][0]++, DefaultValue.step) : _ref4$step;

      cov_108sjousrt.s[68]++;
      this.hold = true;
      cov_108sjousrt.s[69]++;

      if ((cov_108sjousrt.b[35][0]++, e.keyCode !== 38) && (cov_108sjousrt.b[35][1]++, e.keyCode !== 40)) {
        cov_108sjousrt.b[34][0]++;
        cov_108sjousrt.s[70]++;
        return;
      } else {
        cov_108sjousrt.b[34][1]++;
      }

      cov_108sjousrt.s[71]++;
      e.preventDefault();
      var mod = (cov_108sjousrt.s[72]++, e.keyCode === 38 ? (cov_108sjousrt.b[36][0]++, step) : (cov_108sjousrt.b[36][1]++, -step));
      cov_108sjousrt.s[73]++;
      this.changeValue(mod);
      cov_108sjousrt.s[74]++;

      if (this.keyPressTimeOut) {
        cov_108sjousrt.b[37][0]++;
        cov_108sjousrt.s[75]++;
        clearTimeout(this.keyPressTimeOut);
      } else {
        cov_108sjousrt.b[37][1]++;
      }

      cov_108sjousrt.s[76]++;
      this.keyPressTimeOut = setTimeout(function () {
        cov_108sjousrt.f[8]++;
        cov_108sjousrt.s[77]++;

        _this3.longPress(mod);
      }, 600);
    }
  }, {
    key: "handleCalc",
    value: function handleCalc(mod, e) {
      var _this4 = this;

      cov_108sjousrt.f[9]++;

      var _ref5 = (cov_108sjousrt.s[78]++, this.props),
          onMouseDown = _ref5.onMouseDown;

      cov_108sjousrt.s[79]++;

      if (onMouseDown) {
        cov_108sjousrt.b[38][0]++;
        cov_108sjousrt.s[80]++;
        onMouseDown(e);
      } else {
        cov_108sjousrt.b[38][1]++;
      }

      cov_108sjousrt.s[81]++;
      this.hold = true;
      cov_108sjousrt.s[82]++;
      this.changeValue(mod);
      cov_108sjousrt.s[83]++;
      this.keyPressTimeOut = setTimeout(function () {
        cov_108sjousrt.f[10]++;
        cov_108sjousrt.s[84]++;

        _this4.longPress(mod);
      }, 1000);
    }
  }, {
    key: "handleKeyUp",
    value: function handleKeyUp() {
      cov_108sjousrt.f[11]++;
      cov_108sjousrt.s[85]++;
      this.hold = false;
      cov_108sjousrt.s[86]++;

      if (this.keyPressTimeOut) {
        cov_108sjousrt.b[39][0]++;
        cov_108sjousrt.s[87]++;
        clearTimeout(this.keyPressTimeOut);
      } else {
        cov_108sjousrt.b[39][1]++;
      }
    }
  }, {
    key: "handleMouseUp",
    value: function handleMouseUp(e) {
      cov_108sjousrt.f[12]++;

      var _ref6 = (cov_108sjousrt.s[88]++, this.props),
          onMouseUp = _ref6.onMouseUp;

      cov_108sjousrt.s[89]++;

      if (onMouseUp) {
        cov_108sjousrt.b[40][0]++;
        cov_108sjousrt.s[90]++;
        onMouseUp(e);
      } else {
        cov_108sjousrt.b[40][1]++;
      }

      cov_108sjousrt.s[91]++;
      this.hold = false;
      cov_108sjousrt.s[92]++;

      if (this.keyPressTimeOut) {
        cov_108sjousrt.b[41][0]++;
        cov_108sjousrt.s[93]++;
        clearTimeout(this.keyPressTimeOut);
      } else {
        cov_108sjousrt.b[41][1]++;
      }
    }
  }, {
    key: "renderArrowGroup",
    value: function renderArrowGroup() {
      cov_108sjousrt.f[13]++;

      var _ref7 = (cov_108sjousrt.s[94]++, this.props),
          hideArrow = _ref7.hideArrow;

      cov_108sjousrt.s[95]++;

      if (hideArrow) {
        cov_108sjousrt.b[42][0]++;
        cov_108sjousrt.s[96]++;
        return [];
      } else {
        cov_108sjousrt.b[42][1]++;
      }

      cov_108sjousrt.s[97]++;
      return [
      /*#__PURE__*/
      React.createElement("a", {
        key: "up" // do not need the tab to focus
        ,
        tabIndex: -1,
        className: inputClass('number-up'),
        onMouseDown: this.handleAddClick,
        onMouseUp: this.handleMouseUp,
        onMouseLeave: this.handleMouseUp,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 171,
          columnNumber: 7
        }
      }, icons.AngleRight),
      /*#__PURE__*/
      React.createElement("a", {
        key: "down" // do not need the tab to focus
        ,
        tabIndex: -1,
        className: inputClass('number-down'),
        onMouseDown: this.handleSubClick,
        onMouseUp: this.handleMouseUp,
        onMouseLeave: this.handleMouseUp,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 183,
          columnNumber: 7
        }
      }, icons.AngleRight)];
    }
  }, {
    key: "renderRTL",
    value: function renderRTL() {
      cov_108sjousrt.f[14]++;

      var _ref8 = (cov_108sjousrt.s[98]++, this.props),
          onChange = _ref8.onChange,
          allowNull = _ref8.allowNull,
          hideArrow = _ref8.hideArrow,
          value = _ref8.value,
          defaultValue = _ref8.defaultValue,
          other = _objectWithoutProperties(_ref8, ["onChange", "allowNull", "hideArrow", "value", "defaultValue"]);

      cov_108sjousrt.s[99]++;
      return [].concat(_toConsumableArray(this.renderArrowGroup()), [
      /*#__PURE__*/
      React.createElement(Input, Object.assign({
        key: "input",
        value: value
      }, other, {
        className: inputClass((cov_108sjousrt.b[43][0]++, !hideArrow) && (cov_108sjousrt.b[43][1]++, getDirectionClass('number')), 'rtl'),
        onChange: this.handleChange,
        onKeyDown: this.handleKeyDown,
        onKeyUp: this.handleKeyUp,
        onBlur: this.handleBlur,
        cancelBlurChange: true,
        type: "number",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 201,
          columnNumber: 7
        }
      }))]);
    }
  }, {
    key: "render",
    value: function render() {
      cov_108sjousrt.f[15]++;

      var _ref9 = (cov_108sjousrt.s[100]++, this.props),
          onChange = _ref9.onChange,
          allowNull = _ref9.allowNull,
          hideArrow = _ref9.hideArrow,
          defaultValue = _ref9.defaultValue,
          value = _ref9.value,
          other = _objectWithoutProperties(_ref9, ["onChange", "allowNull", "hideArrow", "defaultValue", "value"]);

      var rtl = (cov_108sjousrt.s[101]++, isRTL());
      cov_108sjousrt.s[102]++;

      if (rtl) {
        cov_108sjousrt.b[44][0]++;
        cov_108sjousrt.s[103]++;
        return this.renderRTL();
      } else {
        cov_108sjousrt.b[44][1]++;
      }

      cov_108sjousrt.s[104]++;
      return [
      /*#__PURE__*/
      React.createElement(Input, Object.assign({
        key: "input",
        value: value
      }, other, {
        className: inputClass((cov_108sjousrt.b[45][0]++, !hideArrow) && (cov_108sjousrt.b[45][1]++, getDirectionClass('number'))),
        onChange: this.handleChange,
        onKeyDown: this.handleKeyDown,
        onKeyUp: this.handleKeyUp,
        onBlur: this.handleBlur,
        cancelBlurChange: true,
        type: "number",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 223,
          columnNumber: 7
        }
      }))].concat(_toConsumableArray(this.renderArrowGroup()));
    }
  }]);

  return Number;
}(PureComponent);

Number.defaultProps = DefaultValue;
export default Number;